import React from 'react'
import * as styles from './index.module.css'

export default ({ title, subtitle, components }) => {
  return (
    <div className="gray-wrapper-bg">
      <div className="wrapper">
        <div className={styles.container}>
          <section className={styles.backdrop} />
          <h2 className={styles.title}>{title}</h2>
          <section className={styles.backdrop} />
          <iframe
            title="webviz"
            className={styles.viz}
            src={subtitle.subtitle}
            width="100%"
            height="100%"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
          />
        </div>
      </div>
    </div>
  )
}
